import { useMemo } from 'react';

import { useInitiateDocumentUpload, useSetUploadedDocumentUrl } from 'server';

export const useDocumentUploadPublicAPI = () => {
    const initiateDocumentUpload = useInitiateDocumentUpload();
    const setUploadedDocumentUrl = useSetUploadedDocumentUrl();

    return useMemo(() => ({
        /**
         * Initiates document upload flow and returns a URL to be opened in an iframe / popup / new window.
         * @memberOf Playtech.API.documentUpload
         * @function
         * @param request {Object}
         * @param [request.service] {String}
         * @param [request.successUrl] {String}
         * @param [request.errorUrl] {String}
         * @param [request.documentType] {String}
         * @param [request.remotePaymentAccountId] {String}
         * @returns {Promise<{redirectURL: string, reference: string, sessionId: string, uploadCode: string, nationality: string, accessToken: string}>}
         * @example
         * Playtech.API.documentUpload.initiateDocumentUpload({
         *      errorUrl: 'https://error.com',
         *      documentType: 'PASSPORT',
         *      service: 'netverify',
         *      successUrl: 'https://success.com',
         *      remotePaymentAccountId: 'ePIl8ceR',
         * });
         */
        initiateDocumentUpload,
        /**
         * Stores a link to an externally stored document.
         * @memberOf Playtech.API.documentUpload
         * @function
         * @param request {Object}
         * @param [request.URL] {String}
         * @param [request.documentId] {String}
         * @returns {Promise<void>}
         * @example
         * Playtech.API.documentUpload.setUploadedDocumentUrl({
         *     URL: 'https://example.com/image.jpg',
         *     documentId: '123'
         * });
         */
        setUploadedDocumentUrl
    }), [
        initiateDocumentUpload,
        setUploadedDocumentUrl
    ]);
};
